import type { PortfolioDetailedReturns } from '../../hooks/usePortfolioDetailedReturns';

import { TABLE_OVERVIEW_COLUMN_LENGTH } from '../TableOverview/utils';

import { HoldingOverview } from '../HoldingOverview';

import { getDateRangeString } from '../../utils';
import type { PortfolioType } from '../../../HoldingsTable/hooks';
type Holding = PortfolioDetailedReturns['holdings'][number];

type Props = {
  currencyISO: string;
  holding: Holding;
  portfolioType: PortfolioType;
};

export const EmptyState = ({ holding, currencyISO, portfolioType }: Props) => {
  return (
    <>
      <HoldingOverview
        currencyISO={currencyISO}
        holding={holding}
        portfolioType={portfolioType}
      />
      <tbody>
        <tr aria-label={`${holding.company.uniqueSymbol} Transactions`}>
          <th
            colSpan={TABLE_OVERVIEW_COLUMN_LENGTH}
            className="border-x-0 border-b border-t-0 border-solid border-soft px-x2 py-x0_75 text-left text-tiny font-strong uppercase text-soft"
          >
            <span className="uppercase">Transactions (0)</span>
            <span className="ml-x0_75 text-softer">
              {getDateRangeString(
                holding.detailedReturns.startDate,
                holding.detailedReturns.endDate
              )}
            </span>
          </th>
        </tr>
        <tr>
          <th
            colSpan={TABLE_OVERVIEW_COLUMN_LENGTH}
            className="border-x-0 border-b border-t-0 border-solid border-soft bg-surface-2 px-x2 py-x0_75 text-center text-tiny font-strong text-soft"
          >
            No <span className="uppercase text-good">BUY</span>,{' '}
            <span className="uppercase text-bad">SELL</span>,{' '}
            <span className="uppercase">DIVIDEND</span> or other corporate
            actions in this period
          </th>
        </tr>
      </tbody>
    </>
  );
};
